var _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTestRiesgo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7.5,
    width: 41.5238,
    height: 56,
    rx: 3.53846,
    fill: "white",
    stroke: "#444444"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4284,
    cy: 33.432,
    r: 3.16667,
    fill: "#0099CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4284,
    cy: 42.4797,
    r: 2.66667,
    stroke: "#0099CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4284,
    cy: 51.5273,
    r: 2.66667,
    stroke: "#0099CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 33.8843H42.1902",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 42.9319H42.1902",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 51.9795H42.1902",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9697 26.7755L31.9092 20.8904C32.6851 20.1217 33.9336 20.1156 34.717 20.8767L36.9912 23.0862C37.8079 23.8798 39.121 23.8344 39.8809 22.9862L46.9085 15.1428",
    stroke: "#0099CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6621 16.1266L46.9087 15.1428L46.5808 20.3894",
    stroke: "#0099CC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTestRiesgo);
export default __webpack_public_path__ + "static/media/ico_test_riesgo.db48e69a3e1ff58df1ecf41043013c5b.svg";
export { ForwardRef as ReactComponent };